/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
document.addEventListener('DOMContentLoaded', () => {
    initFormsValidation();
    initModalResponse();
    initVideo();
    initSwitchLanguage();
    initAccordionCard();
    initGallery();
    initCardListTextCta();
});
window.addEventListener('load', (event) => {
    initMegaMenu();
});
